// extracted by mini-css-extract-plugin
export default {"bottom_settings":"locationGroupsItem_bottom_settings__v6JxU"};